export default function FormatDateFilter() {
    return function (date, formatInput, formatOutput) {
        if (typeof date !== 'undefined') {
            if (typeof formatInput === 'undefined') formatInput = "YYYY-MM-DD HH:mm:ss";
            if (typeof formatOutput === 'undefined') formatOutput = "DD/MM/YYYY HH:mm:ss";

            return moment(date, formatInput).format(formatOutput);
        }

        return '-';
    };
}